import { apiSlice } from "../apiSlice";

export const blogMutationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* ---------------- UPDATE BLOG ---------------- */
    updateBlog: builder.mutation({
      query: ({ id, ...updatedFields }) => ({
        url: `blogs/${id}`,
        method: "PUT",
        body: updatedFields,
      }),

      // 👉 invalidate list + detail
      invalidatesTags: (result, error, { id }) => [
        { type: "Blog", id },
        { type: "Blog", id: "LIST" },
      ],
    }),

    /* ---------------- DELETE BLOG ---------------- */
    deleteBlog: builder.mutation({
      query: (id) => ({
        url: `blogs/${id}`,
        method: "DELETE",
      }),

      invalidatesTags: (result, error, id) => [
        { type: "Blog", id },
        { type: "Blog", id: "LIST" },
      ],
    }),

    /* ---------------- ADD BLOG ---------------- */
    addBlog: builder.mutation({
      query: (newBlog) => ({
        url: `blogs`,
        method: "POST",
        body: newBlog,
      }),

      invalidatesTags: [{ type: "Blog", id: "LIST" }],
    }),
  }),
});

export const {
  useAddBlogMutation,
  useUpdateBlogMutation,
  useDeleteBlogMutation,
} = blogMutationApi;
